import React, { useCallback, useEffect, useRef } from "react";
import styles from "./search-box.module.css";

export default function SearchBox({ query = undefined, changeQuery, placeholder }) {
    const ref = useRef(null);

    const handleInput = (e) => {
        debounce(e.target.value);
    };

    const debounceFunction = (callback, delay) => {
        let timer;
        return (value) => {
            clearTimeout(timer);
            timer = setTimeout(() => callback(value), delay);
        };
    };

    const debounce = useCallback(
        debounceFunction((value) => changeQuery(value), 200),
        [],
    );

    return (
        <div className={styles["search-box"]}>
            <input type="text" ref={ref} id={styles["savior-search"]} placeholder={placeholder} autoComplete="off" onInput={handleInput} />
        </div>
    );
}
